"use client";
import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { store } from "../../components/slice/store";
import ErrorBoundaryWrapper from "../../lib/context/ErrorBoundaryWrapper";
import { AppProviders } from "../../lib/context";
import { VideoProvider } from "../../components/video/VideoProvider";
import SiteTitleManager from "../../components/common/SiteTitleManager";

function ClientRoot({ children, cleanHost = "" }) {
  const pathName = usePathname();

  const isExternalDomain =
    cleanHost &&
    (!!cleanHost.endsWith(".circleplug.shop") ||
      (!cleanHost.endsWith("circleplug.shop") &&
        !cleanHost.endsWith("circleplug.com")));

  const isFullWidth =
    isExternalDomain ||
    pathName.includes("/store/") ||
    pathName.includes("/market-place");

  useEffect(() => {
    const maxWidthValue = isFullWidth ? "unset" : "144rem";
    document.documentElement.style.maxWidth = maxWidthValue;
    document.body.style.maxWidth = maxWidthValue;
  }, [isFullWidth]);

  return (
    <>
      <Toaster position="bottom-center" />
      <Provider store={store}>
        <SiteTitleManager />
        <ErrorBoundaryWrapper key={pathName}>
          <AppProviders>
            <VideoProvider>{children}</VideoProvider>
          </AppProviders>
        </ErrorBoundaryWrapper>
      </Provider>
    </>
  );
}

export default ClientRoot;
